var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Hero'),_c('CTA'),_c('HowItWorks'),_c('div',{staticClass:"container mx-auto"},[_c('our-numbers')],1),_c('InstantHelp'),_c('our-advantages'),_c('Services')],1)}
var staticRenderFns = []

export { render, staticRenderFns }